/**
 * Business Management Page - Buried Point Configuration
 * 埋点配置 - 业务管理页
 *
 * ID Allocation:
 * - 100011: Business - Executive Summary page
 * - 100012: Business - Overall Financials page
 * - Buttons: {pageId}001, {pageId}002, etc.
 */

const typeId = 'mgmt_pc_v2';
const source = 0;

// Executive Summary Sub-tab (as a page view)
export const ExecutiveSummaryTab = {
  pageName: 'Business Management - Executive Summary',
  pageId: '100011',
  pagePath: '/strategic/home?tab=business&subtitle=executiveSummary',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100011001',
      buttonName: 'Executive Summary',
    },
    // Business Team Forecast checkbox
    businessTeamForecastCheckbox: {
      buttonId: '100011002',
      buttonName: 'Business Team Forecast',
    },
    // Capabilities & Functions collapse button
    capabilitiesFunctionsCollapse: {
      buttonId: '100011003',
      buttonName: 'Capabilities & Functions',
    },
    // Revenue Notes collapse button
    revenueNotesCollapse: {
      buttonId: '100011004',
      buttonName: 'Revenue Notes',
    },
    // Profit Notes collapse button
    profitNotesCollapse: {
      buttonId: '100011005',
      buttonName: 'Profit Notes',
    },
    // Week Date Picker selection button
    weekDatePicker: {
      buttonId: '100011006',
      buttonName: 'Week Date Picker',
    },
    // Dashboard Metric Header Click button
    dashboardMetricHeaderClick: {
      buttonId: '100011007',
      buttonName: 'Dashboard Metric Header Click',
    },
    // Revenue Notes Edit button
    revenueNotesEdit: {
      buttonId: '100011008',
      buttonName: 'Revenue Notes Edit',
    },
    // Profit Notes Edit button
    profitNotesEdit: {
      buttonId: '100011009',
      buttonName: 'Profit Notes Edit',
    },
    // Weekly Project Highlight Edit button
    weeklyProjectHighlightEdit: {
      buttonId: '100011010',
      buttonName: 'Weekly Project Highlight Edit',
    },
  },
};

// Overall Financials Sub-tab (as a page view)
export const OverallFinancialsTab = {
  pageName: 'Business Management - Overall Financials',
  pageId: '100012',
  pagePath: '/strategic/home?tab=business&subtitle=overallFinancials',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100012001',
      buttonName: 'Overall Financials',
    },
    // Gross Revenue Trend - Bar Chart button
    grossRevenueTrendBarChart: {
      buttonId: '100012002',
      buttonName: 'Gross Revenue Trend - Bar Chart',
    },
    // Gross Revenue Trend - Table button
    grossRevenueTrendTable: {
      buttonId: '100012003',
      buttonName: 'Gross Revenue Trend - Table',
    },
    // Gross Revenue Trend - Download button
    grossRevenueTrendDownload: {
      buttonId: '100012004',
      buttonName: 'Gross Revenue Trend - Download',
    },
    // Profit Trend - Bar Chart button
    profitTrendBarChart: {
      buttonId: '100012005',
      buttonName: 'Profit Trend - Bar Chart',
    },
    // Profit Trend - Table button
    profitTrendTable: {
      buttonId: '100012006',
      buttonName: 'Profit Trend - Table',
    },
    // Profit Trend - Download button
    profitTrendDownload: {
      buttonId: '100012007',
      buttonName: 'Profit Trend - Download',
    },
    financialsThisYearDataDownload: {
      buttonId: '100012008',
      buttonName: `IEGG Financials Dashboard - This Year Data - Download`,
    },
    financialsAllDetailedDataDownload: {
      buttonId: '100012009',
      buttonName: `IEGG Financials Dashboard - All Detailed Data - Download`,
    },
    financialsTimeSeriesDataDownload: {
      buttonId: '100012010',
      buttonName: `IEGG Financials Dashboard - Time Series Data - Download`,
    },
    // Show Events toggle button
    showEvents: {
      buttonId: '100012011',
      buttonName: 'Show Events',
    },
    // Gross Revenue Trend - View button
    grossRevenueTrendView: {
      buttonId: '100012012',
      buttonName: 'Gross Revenue Trend - View',
    },
    // Profit Trend - View button
    profitTrendView: {
      buttonId: '100012013',
      buttonName: 'Profit Trend - View',
    },
    // IEGG Financials Dashboard - Project Collapse/Expand
    financialsProjectCollapse: {
      buttonId: '100012014',
      buttonName: 'IEGG Financials Dashboard - Project Collapse/Expand',
    },
  },
};

// Export all configs
export default {
  executiveSummary: ExecutiveSummaryTab,
  overallFinancials: OverallFinancialsTab,
};

